import { render } from "./App.vue?vue&type=template&id=ebe7e36a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ebe7e36a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe7e36a"]])

export default __exports__